import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Badge,
  Flex,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiActivity, FiFileText, FiArrowRight } from 'react-icons/fi';

const mockClaims = [
  {
    id: 'CLM-1001',
    dateOfService: '2023-10-12',
    status: 'Ready for Rules Engine',
    data: {
      type: '837P',
      patient: { first_name: 'John', last_name: 'Doe', member_id: 'MED123456789' },
      provider: { name: 'Dr. Sarah Jenkins', npi: '1234567890' },
      claim: {
        total_charges: 250.0,
        diagnoses: ['F32.9', 'J45.909'],
        procedures: [
          { cpt: '99213', charge: 150.0 }, // Medical
          { cpt: '90834', charge: 100.0 }, // Behavioral (Triggers Same-Day Rule)
        ],
      },
    },
  },
  {
    id: 'CLM-1002',
    dateOfService: '2023-10-14',
    status: 'Ready for Rules Engine',
    data: {
      type: '837P',
      patient: { first_name: 'Maria', last_name: 'Garcia', member_id: 'MED987654321' },
      provider: { name: 'Dr. Robert Chen', npi: '0987654321' },
      claim: {
        total_charges: 150.0,
        diagnoses: ['I10'],
        procedures: [
          { cpt: '99214', charge: 150.0 }, // Medical only
        ],
      },
    },
  },
  {
    id: 'CLM-1003',
    dateOfService: '2023-10-15',
    status: 'Ready for Rules Engine',
    data: {
      type: '837P',
      patient: { first_name: 'James', last_name: 'Smith', member_id: 'MED456789123' },
      provider: { name: 'Dr. Emily White', npi: '1122334455' },
      claim: {
        total_charges: 100.0,
        diagnoses: ['Z00.00'],
        procedures: [
          { cpt: '99203', charge: 100.0 }, // Medical only
        ],
      },
    },
  },
];

const FqClaimsList = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const theadBg = useColorModeValue('gray.50', 'gray.900');
  const hoverBg = useColorModeValue('gray.50', 'gray.700');

  const handleAnalyze = (claimData) => {
    navigate('/fq/claim/demo', { state: { claimData } });
  };

  return (
    <Box maxW="7xl" mx="auto">
      <Flex justify="space-between" align="flex-end" mb={8}>
        <Box>
          <Heading size="lg" mb={2}>Claims & Rules</Heading>
          <Text color="gray.500">
            Select a claim to run it through the FQHC Rules Engine and Eligibility checks.
          </Text>
        </Box>
      </Flex>

      <Box bg={bgColor} borderRadius="xl" borderWidth="1px" borderColor={borderColor} overflow="hidden" shadow="sm">
        <Table variant="simple">
          <Thead bg={theadBg}>
            <Tr>
              <Th>Claim ID</Th>
              <Th>Date of Service</Th>
              <Th>Patient</Th>
              <Th>Provider</Th>
              <Th isNumeric>Total Charges</Th>
              <Th>Status</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {mockClaims.map((claim) => (
              <Tr key={claim.id} _hover={{ bg: hoverBg }}>
                <Td fontWeight="medium">
                  <Flex align="center">
                    <Icon as={FiFileText} mr={2} color="blue.500" />
                    {claim.id}
                  </Flex>
                </Td>
                <Td>{claim.dateOfService}</Td>
                <Td>{claim.data.patient.first_name} {claim.data.patient.last_name}</Td>
                <Td>{claim.data.provider.name}</Td>
                <Td isNumeric>${claim.data.claim.total_charges.toFixed(2)}</Td>
                <Td>
                  <Badge colorScheme="blue" variant="subtle" display="flex" alignItems="center" w="fit-content">
                    <Icon as={FiActivity} mr={1} />
                    {claim.status}
                  </Badge>
                </Td>
                <Td isNumeric>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    rightIcon={<FiArrowRight />}
                    onClick={() => handleAnalyze(claim.data)}
                  >
                    Analyze Claim
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default FqClaimsList;